import { Problem } from '../types'

export const problems: Problem[] = [
  {
    id: 'reverse-linked-list',
    title: 'Reverse a Linked List',
    description: 'Given the head of a singly linked list, reverse the list and return the reversed list.',
    starterCode: `# Python
class ListNode:
    def __init__(self, val=0, next=None):
        self.val = val
        self.next = next

def reverseList(head):
    # Your code here
    pass

# JavaScript
function ListNode(val, next) {
    this.val = (val===undefined ? 0 : val)
    this.next = (next===undefined ? null : next)
}

function reverseList(head) {
    // Your code here
}

# Java
public class ListNode {
    int val;
    ListNode next;
    ListNode() {}
    ListNode(int val) { this.val = val; }
    ListNode(int val, ListNode next) { this.val = val; this.next = next; }
}

class Solution {
    public ListNode reverseList(ListNode head) {
        // Your code here
        return null;
    }
}

# C++
struct ListNode {
    int val;
    ListNode *next;
    ListNode() : val(0), next(nullptr) {}
    ListNode(int x) : val(x), next(nullptr) {}
    ListNode(int x, ListNode *next) : val(x), next(next) {}
};

class Solution {
public:
    ListNode* reverseList(ListNode* head) {
        // Your code here
        return nullptr;
    }
};`,
    difficulty: 'Easy',
    tags: ['Linked List', 'Recursion', 'Iteration'],
    supportedLanguages: ['python', 'javascript', 'java', 'cpp'],
    testCases: [
      {
        input: '[1,2,3,4,5]',
        expectedOutput: '[5,4,3,2,1]',
        description: 'Basic linked list reversal'
      },
      {
        input: '[1,2]',
        expectedOutput: '[2,1]',
        description: 'Two node list'
      },
      {
        input: '[]',
        expectedOutput: '[]',
        description: 'Empty list'
      }
    ]
  },
  {
    id: 'two-sum',
    title: 'Two Sum',
    description: 'Given an array of integers nums and an integer target, return indices of the two numbers such that they add up to target.',
    starterCode: `# Python
def twoSum(nums, target):
    # Your code here
    pass

# JavaScript
function twoSum(nums, target) {
    // Your code here
}

# Java
class Solution {
    public int[] twoSum(int[] nums, int target) {
        // Your code here
        return new int[0];
    }
}

# C++
class Solution {
public:
    vector<int> twoSum(vector<int>& nums, int target) {
        // Your code here
        return {};
    }
};`,
    difficulty: 'Easy',
    tags: ['Array', 'Hash Map'],
    supportedLanguages: ['python', 'javascript', 'java', 'cpp'],
    testCases: [
      {
        input: 'nums = [2,7,11,15], target = 9',
        expectedOutput: '[0,1]',
        description: 'Basic two sum'
      },
      {
        input: 'nums = [3,2,4], target = 6',
        expectedOutput: '[1,2]',
        description: 'Numbers in middle'
      },
      {
        input: 'nums = [3,3], target = 6',
        expectedOutput: '[0,1]',
        description: 'Same numbers'
      }
    ]
  },
  {
    id: 'valid-parentheses',
    title: 'Valid Parentheses',
    description: 'Given a string s containing just the characters (), {}, and [], determine if the input string is valid.',
    starterCode: `# Python
def isValid(s):
    # Your code here
    pass

# JavaScript
function isValid(s) {
    // Your code here
}

# Java
class Solution {
    public boolean isValid(String s) {
        // Your code here
        return false;
    }
}

# C++
class Solution {
public:
    bool isValid(string s) {
        // Your code here
        return false;
    }
};`,
    difficulty: 'Easy',
    tags: ['Stack', 'String'],
    supportedLanguages: ['python', 'javascript', 'java', 'cpp'],
    testCases: [
      {
        input: '"()"',
        expectedOutput: 'true',
        description: 'Simple parentheses'
      },
      {
        input: '"()[]{}"',
        expectedOutput: 'true',
        description: 'Mixed brackets'
      },
      {
        input: '"(]"',
        expectedOutput: 'false',
        description: 'Invalid brackets'
      }
    ]
  },
  {
    id: 'longest-substring-without-repeating',
    title: 'Longest Substring Without Repeating Characters',
    description: 'Given a string s, find the length of the longest substring without repeating characters.',
    starterCode: `# Python
def lengthOfLongestSubstring(s):
    # Your code here
    pass

# JavaScript
function lengthOfLongestSubstring(s) {
    // Your code here
}

# Java
class Solution {
    public int lengthOfLongestSubstring(String s) {
        // Your code here
        return 0;
    }
}

# C++
class Solution {
public:
    int lengthOfLongestSubstring(string s) {
        // Your code here
        return 0;
    }
};`,
    difficulty: 'Medium',
    tags: ['Hash Map', 'Sliding Window'],
    supportedLanguages: ['python', 'javascript', 'java', 'cpp'],
    testCases: [
      {
        input: '"abcabcbb"',
        expectedOutput: '3',
        description: 'Basic case'
      },
      {
        input: '"bbbbb"',
        expectedOutput: '1',
        description: 'All same characters'
      },
      {
        input: '"pwwkew"',
        expectedOutput: '3',
        description: 'Mixed case'
      }
    ]
  },
  {
    id: 'merge-intervals',
    title: 'Merge Intervals',
    description: 'Given an array of intervals, merge all overlapping intervals.',
    starterCode: `# Python
def merge(intervals):
    # Your code here
    pass

# JavaScript
function merge(intervals) {
    // Your code here
}

# Java
class Solution {
    public int[][] merge(int[][] intervals) {
        // Your code here
        return new int[0][0];
    }
}

# C++
class Solution {
public:
    vector<vector<int>> merge(vector<vector<int>>& intervals) {
        // Your code here
        return {};
    }
};`,
    difficulty: 'Medium',
    tags: ['Array', 'Sorting'],
    supportedLanguages: ['python', 'javascript', 'java', 'cpp'],
    testCases: [
      {
        input: '[[1,3],[2,6],[8,10],[15,18]]',
        expectedOutput: '[[1,6],[8,10],[15,18]]',
        description: 'Basic merge'
      },
      {
        input: '[[1,4],[4,5]]',
        expectedOutput: '[[1,5]]',
        description: 'Adjacent intervals'
      },
      {
        input: '[[1,4],[2,3]]',
        expectedOutput: '[[1,4]]',
        description: 'Overlapping intervals'
      }
    ]
  }
]

export const languageConfigs = {
  python: {
    name: 'Python',
    extension: '.py',
    monacoLanguage: 'python',
    comment: '#',
    functionKeyword: 'def',
    classKeyword: 'class'
  },
  javascript: {
    name: 'JavaScript',
    extension: '.js',
    monacoLanguage: 'javascript',
    comment: '//',
    functionKeyword: 'function',
    classKeyword: 'class'
  },
  java: {
    name: 'Java',
    extension: '.java',
    monacoLanguage: 'java',
    comment: '//',
    functionKeyword: 'public static',
    classKeyword: 'public class'
  },
  cpp: {
    name: 'C++',
    extension: '.cpp',
    monacoLanguage: 'cpp',
    comment: '//',
    functionKeyword: 'int',
    classKeyword: 'class'
  }
} 